module.exports = __webpack_public_path__ + "static/img/bg-overview@m.aaed7bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-tms/bg-overview@m.jpg
// module id = 8FPi
// module chunks = 0